<template>
    <div class="container-fluid p-0 m-0" style="background-color: #000000">
        <div class="row">
            <div class="col-10">
                <localized-link to="/">
                    <img :src="`${publicPath}img/logoRocaGroup_${locale}.png`" width="160"  class="img-responsive my-5">
                </localized-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12">

            <div id="carouselExampleControls" class="carousel slide fullHeight" data-bs-interval="false" data-bs-ride="carousel" data-bs-wrap="true">
                <div class="carousel-inner">
                    <div class="carousel-item active position-relative">
                        <div class="position-absolute">
                            <div class="text-start m-5 p-4 pt-0 mt-0 pe-0">
                                <h1 class="text-white mb-5 pb-5 pe-5" v-html="$t('nav.roca_group_2022')"></h1>
                                <h5 class="text-start my-3"><localized-link to="/roca-group-2022/presentacion">{{ $t("nav.presentacion") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/roca-group-2022/2022-en-resumen">{{ $t("nav.resumen") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/roca-group-2022/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link></h5>
                            </div>
                        </div>
                        <img :src="`${publicPath}img/mobileMenuA.jpg`" class="img-responsive mb-4">
                    </div>
                    <div class="carousel-item">
                        <div class="position-absolute">
                            <div class="text-start m-5 p-4 pt-0 mt-0 pe-0">
                                <h1 class="text-white mb-5 pb-5 pe-5">
                                  <localized-link to="/avanzando-hacia-el-futuro" v-html="$t('nav.avanzando')"></localized-link>
                                </h1>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></h5>
                                <h5 class="text-start my-3"><localized-link to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></h5>
                            </div>
                        </div>
                        <img :src="`${publicPath}img/mobileMenuB.jpg`" class="img-responsive mb-4">
                    </div>
                    <div class="carousel-item">
                        <div class="position-absolute">
                            <div class="text-start m-5 p-4 pt-0 mt-0 pe-0">
                                <h1 class="text-white mb-5 pb-5 pe-5"><localized-link to="/fundacion-we-are-water" v-html="$t('nav.we-are-water')"></localized-link></h1>
                            </div>
                        </div>
                        <img :src="`${publicPath}img/mobileMenuC.jpg`" class="img-responsive mb-4">
                    </div>
                    <div class="carousel-item">
                        <div class="position-absolute">
                            <div class="text-start m-5 p-4 pt-0 mt-0 pe-0">
                                <h1 class="text-white mb-5 pb-5 pe-5"><localized-link to="/informe-financiero" v-html="$t('nav.informe-financero')"></localized-link></h1>
                            </div>
                        </div>
                        <img :src="`${publicPath}img/mobileMenuD_${locale}.jpg`" class="img-responsive mb-4">
                    </div>
                </div>
                <button class="carousel-control-prev mt-0 pt-0" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                    <span class="visually-hidden">{{ $t('previous') }}</span>
                </button>
                <button class="carousel-control-next mt-0 pt-0" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                    <span class="visually-hidden">{{ $t('next') }}</span>
                </button>
            </div>

            </div>

        </div>
    </div>

</template>
<script>
    export default {
        name: "MenuMobileView",
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
            }
        }
    };
</script>
